import { Component, ReactNode } from 'react';

/**
 * pre220 — Fängt Render-Fehler eines Teilbaums ab. Ohne diese Grenze reißt ein
 * Fehler (z. B. im Signatur-Modal / pdf.js) die gesamte Gast-App mit — die dann
 * beim Unmount 'rtc:bye' sendet und den Call abbricht. Mit der Grenze wird nur
 * der betroffene Teil verworfen (onError), der Call läuft weiter.
 */
export class ErrorBoundary extends Component<
  { children: ReactNode; onError?: (error: unknown) => void; fallback?: ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error('[ErrorBoundary] Teilbaum-Fehler abgefangen:', error);
    this.props.onError?.(error);
  }

  render() {
    if (this.state.hasError) return this.props.fallback ?? null;
    return this.props.children;
  }
}
